<section class="history-area jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="history-content">
            <a href="https://www.youtube.com/watch?v=Y5KCDWi7h9o" class="video-btn popup-youtube"><i class="flaticon-play"></i></a>
            <h2>Our history</h2>
        </div>
    </div>
</section>